// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	IdvFeeAmountInput: 'idv-fee-amount-input',
} as const;
